module.exports = __webpack_public_path__ + "img/section1-image2.41ee7db7.png";